import { registerActions } from "../actionRegistry";
import { api } from "../api";
import { toastSuccess, toastError } from "../ui/messages";
import { getDomElement, h } from "../utils/dom";

// follow type: 1 = artist, 2 = collection, 3 = search url (matches the raft `follow` route).
const isFollowType = (n: number): n is 1 | 2 | 3 => n === 1 || n === 2 || n === 3;

/**
 * Repaint `#follow-container` with the button for the CURRENT state.
 *
 * Both halves used to write the markup with `setHtml` and then bind via
 * `queryAll("#follow-container span")` — a selector that would have picked up
 * any other span the container gained, and which only worked because the button
 * happened to be the container's sole child. Building the node binds to the
 * element itself, and the two near-identical bodies collapse into one.
 */
function renderFollowButton(following: boolean, type: string, type_name: string, id: string): void {
  const container = getDomElement("follow-container");
  if (!container) return;

  const button = following
    ? h("span", "button medium follow-off", "Un-follow")
    : h("span", "button medium follow", h("i", "fas fa-star"), " Follow");

  button.addEventListener("click", () =>
    following ? dounfollow(type, type_name, id) : dofollow(type, type_name, id)
  );
  container.replaceChildren(button);
}

export function dofollow(type: string, type_name: string, id: string): void {
  const followType = Number(type);
  if (!isFollowType(followType)) return;
  api.follow
    .follow({ id, type: followType })
    .then(() => {
      renderFollowButton(true, type, type_name, id);
      toastSuccess(`You are now following this ${type_name}`);
    })
    .catch((err: unknown) => {
      toastError((err as Error).message);
    });
}

export function dounfollow(type: string, type_name: string, id: string): void {
  api.follow
    .unfollow({ followContentId: id, followType: Number(type) })
    .then(() => {
      renderFollowButton(false, type, type_name, id);
      toastSuccess(`You are no longer following this ${type_name}`);
    })
    .catch((err: unknown) => {
      toastError((err as Error).message);
    });
}

export function followremove(id: string): void {
  if (!confirm("Are you sure you want to unfollow this content?")) return;
  api.follow
    .remove({ id })
    .then(() => {
      getDomElement(`followid-${id}`)?.remove();
      toastSuccess("Follow removed");
    })
    .catch((err: unknown) => {
      toastError((err as Error).message);
    });
}

registerActions({
  dofollow,
  dounfollow,
});
